// v3.4 (F3) voice input — Web Speech API (browser / installable PWA). A native Capacitor
// speech plugin can later be swapped in behind this same interface. The transcript becomes
// plain text in the composer — no audio is sent to the backend, so there's no new endpoint
// and no new PII at rest. Callers feature-detect with voiceSupported() and hide the mic if
// unsupported (e.g. Firefox, some iOS).
export const voiceSupported = () =>
  typeof window !== 'undefined' && !!(window.SpeechRecognition || window.webkitSpeechRecognition)

export function createRecognizer({ onResult, onEnd, onError, lang = 'en-US' } = {}) {
  const SR = typeof window !== 'undefined' ? (window.SpeechRecognition || window.webkitSpeechRecognition) : null
  if (!SR) return null
  const rec = new SR()
  rec.lang = lang
  rec.interimResults = true
  rec.continuous = false
  let finalText = ''
  rec.onresult = (e) => {
    let interim = ''
    for (let i = e.resultIndex; i < e.results.length; i++) {
      const t = e.results[i][0].transcript
      if (e.results[i].isFinal) finalText += t
      else interim += t
    }
    onResult && onResult((finalText + interim).trim(), finalText.trim())
  }
  rec.onerror = (e) => onError && onError(e)
  rec.onend = () => onEnd && onEnd(finalText.trim())
  return {
    start: () => { finalText = ''; try { rec.start() } catch { /* already running */ } },
    stop: () => { try { rec.stop() } catch { /* ignore */ } },
  }
}

export default { voiceSupported, createRecognizer }
